import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes/Routes';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css'
import * as serviceWorker from './serviceWorker';
import history from './history';

const AppCore = () => (
    <BrowserRouter basename='/' history={history}>

        <Routes/>

    </BrowserRouter>
);


ReactDOM.render(
  <AppCore />,
  document.getElementById('root')
  );

serviceWorker.unregister();